var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "my-2" }, [
                  _c(
                    "div",
                    {},
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-base leading-6 font-medium text-gray-900 my-2"
                        },
                        [_vm._v(" Select Date ")]
                      ),
                      _c("DateRangePicker", {
                        attrs: { opens: "right", ranges: _vm.ranges },
                        on: { update: _vm.dateSelected },
                        model: {
                          value: _vm.currentConfig,
                          callback: function($$v) {
                            _vm.currentConfig = $$v
                          },
                          expression: "currentConfig"
                        }
                      }),
                      _vm.isLoading ? _c("div", [_c("Spinner")], 1) : _vm._e(),
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-lg leading-6 font-medium text-gray-900 mt-5"
                        },
                        [_vm._v(" Abandoned carts ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Messages sent ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.automationReport
                                              .abandonedCartMessageSent
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Carts recovered ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.cartReport.cartsRecovered
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-lg leading-6 font-medium text-gray-900 mt-5"
                        },
                        [_vm._v(" Welcome Messages ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Subscribers Added ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.subscriberReport.subscribers
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white overflow-hidden shadow rounded-lg"
                            },
                            [
                              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                                _c("dl", [
                                  _c(
                                    "dt",
                                    {
                                      staticClass:
                                        "text-sm leading-5 font-medium text-gray-500 "
                                    },
                                    [_vm._v(" Messages Sent ")]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.automationReport
                                              .welcomeMessageSent
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      ),
                      _c("OnboardingChecklist", { staticClass: "my-4" })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }